import { lazy } from "react";

const StepsAppLayout = lazy(() => import("./StepsAppLayout"));

export { StepsAppLayout };
